<template>
  <v-col class="mx-auto" cols="12" lg="6" md="8">
    <v-switch v-model="is_active" color="indigo" label="تنظیمات"></v-switch>

    <div v-if="is_active">
      <div v-if="timeRequire === false" class="col-md-12 px-0">
        <automatics
          :AutoSend="false"
          :multi-ads="false"
          :time="true"
        ></automatics>
      </div>

      <v-switch
        v-if="!market"
        v-model="contact.autoPay"
        class="datePick"
        color="indigo"
        hide-details
        label="پرداخت اتوماتیک"
      ></v-switch>

      <!-- <v-switch
        v-model="contact.chat_enabled"
        class="datePick"
        color="indigo"
        hide-details
        label="فعال کردن چت دیوار"
      ></v-switch>

      <v-switch
        v-model="contact.hide_phone"
        class="datePick text-right"
        color="indigo"
        hide-details
        label="شماره تلفن در آگهی نمایش داده نشود."

      ></v-switch> -->
    </div>
  </v-col>
</template>

<script>
import Automatics from "@/view/pages/ads/timeHandelers/automatics";
import { Bus } from "@/main";

export default {
  name: "settingAds",

  props: {
    timeRequire: {
      default: false,
    },
    market: {
      default: false,
    },
    editMode: {
      default: () => {
        return {
          chat_enabled: true,
          hide_phone: false,
          autoPay: false,
        };
      },
    },
    autoPay: {
      default: false,
    },
  },

  data() {
    return {
      contact: this.editMode,
      is_active: true,
    };
  },

  components: { Automatics },

  watch: {
    is_active(val) {
      this.$emit("setSettingAds", val);
    },
    defaultAds(val) {
      this.$emit("setSettingAds", val);
    },
    contact: {
      handler: function (val) {
        Bus.$emit("contact", val);
        if (val.hide_phone === true) {
          this.contact.chat_enabled = true;
        }
      },
      deep: true,
    },
    editMode: function (val) {
      this.contact.hide_phone = val.hide_phone;
      this.contact.chat_enabled = val.chat_enabled;
      this.contact.autoPay = this.autoPay;
    },
  },
};
</script>

<style scoped></style>
